export default "__VITE_ASSET__DU1rYoe8__"